import { createSlice } from '@reduxjs/toolkit'

export const popupSlice = createSlice({
  name: 'popup',
  initialState: {
    value: {
        show: false, x: 0, y: 0, data: {
        
        }
    },
  },
  reducers: {
    setPopup: (state, action) => {
  
      state.value =action.payload
    },
    
   
  },
})

// Action creators are generated for each case reducer function
export const { setPopup } = popupSlice.actions

export default popupSlice.reducer